document.addEventListener('DOMContentLoaded', function () {
    var mainEl = document.getElementById('product_slider');
    if (!mainEl) return;

    var thumbEl = document.getElementById('thumbnail-slider');
    var thumbCount = thumbEl ? thumbEl.querySelectorAll('.splide__slide').length : 0;

    var main = new Splide('#product_slider', {
        type: 'slide',
        perPage: 1,
        pagination: false,
        arrows: true,
        gap: 0,
    });

    if (thumbEl && thumbCount > 0) {
        var thumbnails = new Splide('#thumbnail-slider', {
            type: 'slide',
            gap: 10,
            perPage: 4.5,
            pagination: false,
            arrows: false,
            cover: true,
            rewind: true,
            isNavigation: true,
            focus: thumbCount > 4 ? 'center' : false,
            breakpoints: {
                768: { perPage: 3.5, gap: 6 }
            },
        });

        // Progress bar — register BEFORE mount so 'mounted' event fires
        thumbnails.on('mounted move', function () {
            var end = thumbnails.Components.Controller.getEnd();
            var bar = thumbEl.querySelector('.splide-progress-bar');
            if (!bar) return;
            if (end <= 0) {
                bar.style.width = '100%';
            } else {
                bar.style.width = (((thumbnails.index + 1) / (end + 1)) * 100) + '%';
            }
        });

        // Original working mount order: main first, then thumbnails, then sync
        main.mount();
        thumbnails.mount();
        main.sync(thumbnails);

    } else {
        main.mount();
    }

    window.productSlider = main;
});

document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('product_slider')) {
        new SimpleLightbox('#product_slider a', {
            history: true,
            alertError: false,
            additionalHtml: false,
            loop: true,
            overlayOpacity: 1,
            doubleTapZoom: 2,
            fadeSpeed: 50,
            animationSpeed: 50,
            swipeClose: false,
            enableZoom: true
        });
    }
});
